// extracted by mini-css-extract-plugin
export default {"SegmentedControl":"MarkdownReferencePreview-module__SegmentedControl--Q7TCz"};